import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
} from "reactstrap";
import { FULLSTORY_ELEMENTS } from "utils/fullstoryElements";
import logoWithText from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/rectangle-logo-v2.png";

const LandingPageTopNav = ({
  scrollToFeatures,
  scrollToPricing,
  scrollToFaq,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScrollLink = (scrollFn) => (event) => {
    event.preventDefault();
    setIsMenuOpen(false);
    if (typeof scrollFn === "function") {
      window.setTimeout(() => scrollFn(), 260);
    }
  };

  const closeMenu = () => setIsMenuOpen(false);

  const featuresNavItem = scrollToFeatures ? (
    <button
      type="button"
      className="landing-nav-link"
      onClick={handleScrollLink(scrollToFeatures)}
    >
      Features
    </button>
  ) : (
    <Link to="/#how-it-works" className="landing-nav-link" onClick={closeMenu}>
      Features
    </Link>
  );

  const pricingNavItem = scrollToPricing ? (
    <button
      type="button"
      className="landing-nav-link"
      onClick={handleScrollLink(scrollToPricing)}
    >
      Pricing
    </button>
  ) : (
    <Link to="/pricing" className="landing-nav-link" onClick={closeMenu}>
      Pricing
    </Link>
  );

  const helpCenterNavItem = scrollToFaq ? (
    <button
      type="button"
      className="landing-nav-link"
      onClick={handleScrollLink(scrollToFaq)}
    >
      FAQ
    </button>
  ) : (
    <Link to="/#faq" className="landing-nav-link" onClick={closeMenu}>
      FAQ
    </Link>
  );

  const navLinks = (
    <>
      {featuresNavItem}
      {pricingNavItem}
      <Link to="/for-administrators" className="landing-nav-link" onClick={closeMenu}>
        Schools &amp; Districts
      </Link>
      {helpCenterNavItem}
    </>
  );

  const loginButton = (
    <Button
      tag={Link}
      to="/auth/login"
      className="btn btn-secondary design-system-secondary-outline landing-nav-btn landing-nav-btn--secondary"
      onClick={closeMenu}
      data-fs-element={FULLSTORY_ELEMENTS.landing.navLogin}
    >
      Login
    </Button>
  );

  const trialButton = (
    <Button
      tag={Link}
      to="/auth/register"
      className="btn design-system-primary-solid landing-nav-btn landing-nav-btn--primary"
      onClick={closeMenu}
      data-fs-element={FULLSTORY_ELEMENTS.landing.navTrial}
    >
      Start Your Free Trial
    </Button>
  );

  const mobileHeaderTrialButton = (
    <Button
      tag={Link}
      to="/auth/register"
      className="btn design-system-primary-solid landing-nav-btn landing-nav-btn--primary landing-nav-btn--mobile-header"
      onClick={closeMenu}
      data-fs-element={FULLSTORY_ELEMENTS.landing.navTrial}
    >
      Start Your Free Trial
    </Button>
  );

  return (
    <div className="landing-nav-shell">
      <Navbar className="landing-navbar navbar-light bg-white" expand={false}>
        <div className="landing-navbar-inner landing-navbar-inner--responsive">
          <NavbarBrand className="landing-nav-brand">
            <Link to="/" onClick={closeMenu}>
              <img
                src={logoWithText}
                alt="Lesson Launchpad"
                className="landing-nav-logo"
              />
            </Link>
          </NavbarBrand>

          <div className="landing-nav-links landing-nav-links--desktop">{navLinks}</div>

          <div className="landing-nav-actions landing-nav-actions--desktop">
            {loginButton}
            {trialButton}
          </div>

          <div className="landing-nav-actions landing-nav-actions--mobile-header">
            {mobileHeaderTrialButton}
          </div>

          <NavbarToggler
            className="landing-nav-toggler landing-nav-toggler--responsive"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            <span className="landing-nav-toggler-icon" />
          </NavbarToggler>
        </div>

        <Collapse isOpen={isMenuOpen} navbar className="landing-nav-mobile-menu">
          <Nav navbar className="landing-nav-mobile-links">
            {scrollToFeatures ? (
              <button
                type="button"
                className="landing-nav-mobile-link"
                onClick={handleScrollLink(scrollToFeatures)}
              >
                Features
              </button>
            ) : (
              <Link to="/#how-it-works" className="landing-nav-mobile-link" onClick={closeMenu}>
                Features
              </Link>
            )}
            {scrollToPricing ? (
              <button
                type="button"
                className="landing-nav-mobile-link"
                onClick={handleScrollLink(scrollToPricing)}
              >
                Pricing
              </button>
            ) : (
              <Link to="/pricing" className="landing-nav-mobile-link" onClick={closeMenu}>
                Pricing
              </Link>
            )}
            <Link
              to="/for-administrators"
              className="landing-nav-mobile-link"
              onClick={closeMenu}
            >
              Schools &amp; Districts
            </Link>
            {scrollToFaq ? (
              <button
                type="button"
                className="landing-nav-mobile-link"
                onClick={handleScrollLink(scrollToFaq)}
              >
                FAQ
              </button>
            ) : (
              <Link to="/#faq" className="landing-nav-mobile-link" onClick={closeMenu}>
                FAQ
              </Link>
            )}
            <Link
              to="/auth/login"
              className="landing-nav-mobile-link"
              onClick={closeMenu}
            >
              Login
            </Link>
          </Nav>
          <div className="landing-nav-mobile-actions">
            {trialButton}
          </div>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default LandingPageTopNav;
